import axios from 'axios';

const BASE = '/project-management/inbox';

/**
 * Fetch AI Inbox Summary briefing for the requested period
 */
export const getAiSummary = async (params = {}) => {
    const response = await axios.get(`${BASE}/summary`, { params });
    return response.data;
};

/**
 * Explicitly refresh the AI Inbox Summary briefing
 */
export const refreshAiSummary = async (payload = {}) => {
    const response = await axios.post(`${BASE}/summary/refresh`, payload);
    return response.data;
};

/**
 * Fetch inbox feed items
 */
export const getInboxFeed = async (params = {}) => {
    const response = await axios.get(`${BASE}`, { params });
    
    return response.data;
};

/**
 * Toggle read / unread status
 */
export const updateItemReadState = async (id, read) => {
    const response = await axios.patch(`${BASE}/${id}/read`, { read });
    return response.data;
};

/**
 * Toggle bookmark
 */
export const updateItemBookmark = async (id, bookmarked) => {
    const response = await axios.patch(`${BASE}/${id}/bookmark`, { bookmarked });
    return response.data;
};

/**
 * Toggle archive
 */
export const updateItemArchive = async (id, archived) => {
    const response = await axios.patch(`${BASE}/${id}/archive`, { archived });
    return response.data;
};

/**
 * Execute operational action (approve, accept, resolve_blocker, request_changes)
 */
export const executeItemAction = async (id, payload) => {
    const response = await axios.patch(`${BASE}/${id}/action`, payload);
    return response.data;
};

/**
 * Mark all items as read
 */
export const markAllItemsAsRead = async (itemIds = []) => {
    const response = await axios.post(`${BASE}/read-all`, { itemIds });
    return response.data;
};

